<template>
    <VirtualScrollTable
        :columns="columns"
        :columnHiddenOption="columnHiddenOption"
        :data="coursesData"
        class="user-table"
        :max-height="500"
    />
</template>

<script>
import VirtualScrollTable from 'components/user/organizationreport/tables/VirtualScrollTable'
import convertMinutesToHours from 'components/shared/mixins/convertMinutesToHours'
import {translateWithDefault} from 'helpers/i18nHelper'
import moment from 'moment-timezone'

export default {
    components: { VirtualScrollTable },
    mixins: [convertMinutesToHours],
    props: {
        data: {
            type: Array
        }
    },
    computed: {
        columnHiddenOption () {
            return this.$totemLang === 'dk'
                ? { defaultHiddenColumnKeys: ['instructor', 'level', 'authorizationTypes'] }
                : { defaultHiddenColumnKeys: ['instructor', 'level'] }
            }
    },
    data () {
        return {
            coursesData: [],
            columns: [
                {
                    field: 'title',
                    key: 'title',
                    title: this.$t('ReportingTable.name'),
                    align: 'left',
                    sortBy: 'asc',
                    renderBodyCell: ({row, column, rowIndex}, h) => {
                        const title = row[column.field]
                        const instructor = row.instructor
                        const level = row.level
                        let boldClasses = 'table-cell --bold'
                        let blockClasses = 'table-cell --block'

                        return (
                            <div>
                                <span class={boldClasses}>{title}</span>
                                <span class={blockClasses}>{this.$t('ReportingTable.instructor')}: {instructor}</span>
                                <span class={blockClasses}>{this.$t('ReportingTable.level')}: { this.$t(`Select.skill_level_${level}`) }</span>
                            </div>
                        )
                    }
                },
                {
                    field: 'type',
                    key: 'type',
                    title: this.$t('ReportingTable.learning_format'),
                    align: 'left',
                    sortBy: '',
                    width: 150
                },
                {
                    field: 'duration',
                    key: 'duration',
                    title: this.$t('ReportingTable.duration'),
                    align: 'left',
                    sortBy: '',
                    width: 100,
                    renderBodyCell: ({row, column, rowIndex}, h) => {
                        const duration = row[column.field]
                        return this.convertMinutesToHours(duration)
                    }
                },
                {
                    field: 'subjectAreas',
                    key: 'subjectAreas',
                    title: this.$t('ReportingTable.subject_areas'),
                    align: 'left',
                    width: 250,
                    renderBodyCell: ({row, column, rowIndex}, h) => {
                        const subjectAreaArray = row[column.field]
                        const subjectAreas = subjectAreaArray.map(subject => {
                            return translateWithDefault(subject, subject)
                        })
                        return subjectAreas.join(', ')
                    }
                },
                {
                    field: 'categories',
                    key: 'categories',
                    title: this.$t('ReportingTable.categories'),
                    align: 'left',
                    width: 220,
                    renderBodyCell: ({row, column, rowIndex}, h) => {
                        const categories = row[column.field]
                        return categories.join(', ')
                    }
                },
                {
                    field: 'progressPercentage',
                    key: 'progressPercentage',
                    title: this.$t('ReportingTable.progress'),
                    align: 'left',
                    sortBy: '',
                    width: 100,
                    renderBodyCell: ({row, column, rowIndex}, h) => {
                        const progress = row[column.field]

                        if (progress === 100) {
                            return <span class="table-cell --bold">{progress} %</span>
                        }
                        return <span>{progress} %</span>
                    }
                },
                {
                    field: 'dateStarted',
                    key: 'dateStarted',
                    title: this.$t('ReportingTable.started'),
                    align: 'left',
                    sortBy: '',
                    width: 120,
                    renderBodyCell: ({row, column, rowIndex}, h) => {
                        const dateStarted = row[column.field]
                        return moment(dateStarted).format('DD.MM.YYYY')
                    }
                },
                {
                    field: 'dateCompleted',
                    key: 'dateCompleted',
                    title: this.$t('ReportingTable.completed'),
                    align: 'left',
                    sortBy: '',
                    width: 120,
                    renderBodyCell: ({row, column, rowIndex}, h) => {
                        const dateCompleted = row[column.field]
                        if (dateCompleted !== null) {
                            return moment(dateCompleted).format('DD.MM.YYYY')
                        }
                    }
                },
                {
                    field: 'authorizationTypes',
                    key: 'authorizationTypes',
                    title: this.$t('ReportingTable.authorization'),
                    align: 'left',
                    width: 150,
                    renderBodyCell: ({row, column, rowIndex}, h) => {
                        const authArray = row[column.field]
                        if (authArray !== null) {
                            const authorizations = authArray.map(auth => {
                                return auth.credits + ' ' + auth.label
                            })
                            return <span class="table-cell --bagde --authorizations">{authorizations}</span>
                        }
                    }
                }
            ]
        }
    },
    methods: {
        modifyData () {
            const courses = this.data.map(course => {
                return {
                    ...course,
                    rowKey: course.id
                }
            })
            this.coursesData = courses
        }
    },
    watch: {
        data: {
            handler: 'modifyData'
        }
    }
}
</script>

<style lang="scss">

.user-table {
    .table-cell {
        &.--bold {
            font-family: Nunito-ExtraBold, sans-serif;
        }

        &.--block {
            display: block;
        }

        &.--bagde {
            border-radius: 20px;
            padding: 4px 10px;
            display: inline-block;
            margin: 0 5px 5px 0;
        }

        &.--authorizations {
            background: $light_orange;
        }
    }
}
</style>
